import { render, staticRenderFns } from "./order-import.vue?vue&type=template&id=37ed0b06&scoped=true&"
import script from "./order-import.vue?vue&type=script&lang=js&"
export * from "./order-import.vue?vue&type=script&lang=js&"
import style0 from "./order-import.vue?vue&type=style&index=0&id=37ed0b06&lang=scss&"
import style1 from "./order-import.vue?vue&type=style&index=1&id=37ed0b06&scoped=true&lang=scss&"
import style2 from "./order-import.vue?vue&type=style&index=2&id=37ed0b06&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed0b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ed0b06')) {
      api.createRecord('37ed0b06', component.options)
    } else {
      api.reload('37ed0b06', component.options)
    }
    module.hot.accept("./order-import.vue?vue&type=template&id=37ed0b06&scoped=true&", function () {
      api.rerender('37ed0b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/delivery/order-import.vue"
export default component.exports